import React from 'react';
import {
  AutocompleteArrayInput,
  Edit,
  FileInput,
  ImageField,
  ReferenceArrayInput,
  SimpleForm,
  TextInput,
  FormDataConsumer,
  NumberInput,
} from 'react-admin';
import { API_BASE_URL } from '../../../../utils/constants';
import caseCategoriesValidation from '../validation';

const CaseCategoriesEdit = props => (
  <Edit {...props} mutationMode="pessimistic" >
    <SimpleForm validate={caseCategoriesValidation}>
      <FileInput source="image" label="Background" accept="image/*" placeholder={<p>Drop your image here</p>}>
        <ImageField source="src" title="title" />
      </FileInput>

      <FormDataConsumer>
        {({ formData }) => {
          if (formData?.image && (typeof formData?.image === 'string')) {
            return (
              <>
                <h3 className="original-image__label" >Original Image</h3>
                <div className="original-image__container">
                  <img
                    className="original-image__image"
                    src={`${API_BASE_URL}${formData.image}`}
                    alt="background"
                  />
                </div>
              </>
            );
          }
        }}
      </FormDataConsumer>

      <TextInput source="name_dk" label="Danish name" fullWidth />
      <TextInput source="header_dk" label="Danish header" fullWidth />
      <TextInput source="description_dk" label="Danish description" fullWidth />
      <TextInput source="name_en" label="English name" fullWidth />
      <TextInput source="header_en" label="English header" fullWidth />
      <TextInput source="description_en" label="English description" fullWidth />
      <TextInput source="slug" label="Slug" fullWidth />
      <NumberInput source="order" />
      <ReferenceArrayInput reference="case-list" source="cases" perPage={10000} >
        <AutocompleteArrayInput
          optionText="name_en"
          filterToQuery={searchText => ({
              searchReference: searchText,
            })
          }
        />
      </ReferenceArrayInput>
    </SimpleForm>
  </Edit >
);

export default CaseCategoriesEdit;
